import React, { useEffect, useState }  from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import { Dropdown } from 'semantic-ui-react';

import LibraryControlAction from '../../actions/v2/plan';
import { getText } from '../../helpers';
import { CHANGE_LOG_FILTERS } from '../../constants';

import './plan_change_logs_modal.css'

const PlanChangeLogsModal = (props) => {
  const perPage = 15;
  const [ changeLogs, setChangeLogs ] = useState([]);
  const [ page, setPage] = useState(1);
  const [ filters, setFilters ] = useState([]);
  const filterOptions = CHANGE_LOG_FILTERS.map((filter) => ({
    ...filter,
    text: getText(filter.text),
  }));

  const setNewPage = () => {
    if (props.plan.changeLogs.length < perPage) return;
    setPage(page + 1)
  }

  useEffect(()=>{
    const params = { plan_id: props.plan_id, per_page: perPage, page, log_filters: filters }
    props.getPlanChangeLogs(params);
  }, [page, filters])

  useEffect(()=>{
    if (page == 1) return setChangeLogs(props.plan.changeLogs);
    setChangeLogs(changeLogs.concat(props.plan.changeLogs));
  }, [props.plan.changeLogs])

  const handleDropdownChange = (e, { value }) => {
    setFilters(value);
    setPage(1);
  }

  return (
    <Draggable handle=".plan-change-logs-header">
      <div className="plan-change-logs">
        <div className="plan-change-logs-header">
          <i className="delete icon" onClick={ props.onClose }></i>
          <div id="plan-change-logs-instructions">
            <div>{getText("Plan Change Logs")}</div>
            <Dropdown
              className="plan-change-logs-dropdown"
              placeholder={getText("Filter Change Logs")}
              value={filters}
              options={filterOptions}
              onChange={handleDropdownChange}
              fluid
              multiple
              selection
              closeOnBlur
              closeOnChange
            ></Dropdown>
          </div>
          <div className="delete-icon-position"></div>
        </div>
        <InfiniteScroll
          dataLength={changeLogs.length}
          next={setNewPage}
          hasMore={true}
          height={1}
        >
          <div className="plan-change-logs-content">
            { 
              changeLogs && changeLogs.length > 0 ?
              <table className="table plan-change-logs-table">
                <thead>
                  <tr>
                    <th className="date-header">{getText("Date Created")}</th>
                    <th className="description-header">{getText("Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    changeLogs.map((log, index)=>{
                      return (
                        <tr key={index}>
                          <td>{ moment(log.created_at).format("DD MMM YYYY hh:mm A") }</td>
                          <td>{ log.description }</td>
                        </tr>
                      )
                    })
                  }

                </tbody>
              </table>
              :
              <span>{getText("No changes found")}</span>
            }
          </div>
        </InfiniteScroll>
      </div>
    </Draggable>
  );
}

const mapStateToProps = (state) => {
  return {plan: state.plan };
}

const mapDispatchToProps = (dispatch) => {
  const libraryControlAction = new LibraryControlAction();

  return {
    getPlanChangeLogs: (options) => {
      dispatch(libraryControlAction.getPlanChangeLogs(options))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(PlanChangeLogsModal);



// WEBPACK FOOTER //
// ./src/views/plan_change_logs/plan_change_logs_modal.js